export type Category = {
  slug: string;
  name: string;
  tagline: string;
  icon: string;
  intro: string;
};

export type NewsItem = {
  id: number;
  category: string;
  title: string;
  lead: string;
  body: string[];
  cover: string;
  author: string;
  time: string;
  views: number;
  likes: number;
  readMin: number;
  tags: string[];
  exclusive?: boolean;
  hot?: boolean;
  featured?: boolean;
};

export const site = {
  name: "今日新瓜",
  slogan: "独家内幕 · 独家爆料 · 独家栏目",
  desc: "专注文娱内幕与深度吃瓜的内容平台。只有你想不到，没有我们挖不到的瓜。",
  email: "contact@jinrixingua.example.com",
  notice:
    "本站内容为编辑部策划的泛娱乐资讯与虚构情景演示，仅作栏目呈现与阅读体验之用。",
};

export const categories: Category[] = [
  {
    slug: "exclusive",
    name: "独家内幕",
    tagline: "只此一家 · 深挖不为人知的内幕",
    icon: "ri-flashlight-fill",
    intro:
      "编辑部卧底一线多年沉淀的独家内幕，还原事件幕后真正的来龙去脉。",
  },
  {
    slug: "scene",
    name: "娱乐现场",
    tagline: "红毯 · 舞台 · 镜头第一时间",
    icon: "ri-camera-3-fill",
    intro: "发布会、颁奖礼与片场实录，把现场最有信息量的一帧还原给你。",
  },
  {
    slug: "star",
    name: "明星动态",
    tagline: "作品与生活 · 台前与幕后",
    icon: "ri-star-fill",
    intro: "关注艺人作品规划、团队动向与幕后再公开的另一面。",
  },
  {
    slug: "variety",
    name: "综艺热播",
    tagline: "热搜名场面 · 真实剧本",
    icon: "ri-tv-2-fill",
    intro: "拆解综艺名场面背后的录制逻辑与剪辑真相。",
  },
  {
    slug: "trending",
    name: "吃瓜热议",
    tagline: "全网都在聊的那颗瓜",
    icon: "ri-chat-heart-fill",
    intro: "聚合全网热议话题，梳理事件时间线与各方回应。",
  },
  {
    slug: "feature",
    name: "深度报道",
    tagline: "不追逐热搜 · 只挖来龙去脉",
    icon: "ri-scales-3-fill",
    intro: "用更长的时间跨度观察行业变迁与人物成长。",
  },
];

export const news: NewsItem[] = [
  {
    id: 1,
    category: "exclusive",
    exclusive: true,
    hot: true,
    featured: true,
    title: "新剧筹备半年忽然停摆：圈内人独家还原“乙组停工”前夜的三个信号",
    lead: "一部原定下月开机的大制作，被爆一周内集体撤组。多位不愿具名的剧组人员向今日新瓜还原了停工前的种种异常。",
    body: [
      "消息在组内传开时，很多人还以为只是普通调整。但连续三天，原本排好的围读会被接连取消，几个核心统筹的手机一度处于无人接听状态——这是项目组里少见的情形。",
      "据一位接近资方的内部人士透露，停摆并非单点资金问题，而是平台对剧本方向提出了整体重估。相比临时补拍，更多是预算口径与排期口径对不上，导致整个制片节奏被推翻重排。",
      "截至发稿，项目方仍未就停工原因给出官方说明。今日新瓜将持续跟进，若你有相关线索，欢迎通过底部邮箱向编辑部独家爆料。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=dramatic_film_production_studio_with_clapperboard_and_cinema_lights_silhouettes_of_crew_in_shadow_warm_amber_and_deep_red_editorial_moody_lighting_no_identifiable_faces_stylized_cinematic_scene&width=1200&height=800&seq=news-01-excl&orientation=landscape",
    author: "今日新瓜 · 深挖组",
    time: "8 分钟前",
    views: 486000,
    likes: 31200,
    readMin: 6,
    tags: ["独家", "剧组", "内幕"],
  },
  {
    id: 2,
    category: "exclusive",
    exclusive: true,
    hot: true,
    title: "所谓“圈内旧识”真有那么熟？独家比对两人十年同框记录",
    lead: "一张模糊合影引出无数联想。今日新瓜用十年代际时间线，逐条比对他们真正公开同框与私下交集的可能。",
    body: [
      "网友整理出的同框记录看起来热闹，但细看时间戳，真正两人同时在场的公开活动其实屈指可数。",
      "我们查阅了历年活动通稿与媒体图库，多数所谓同框来自同一场群星活动的后台大合影，实际私交证据并不充分。",
      "结论先行：两人事业上或有交集，但关系被明显放大。真正有价值的信息，往往藏在最不起眼的行程表里。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=two_mysterious_figures_in_quiet_chat_over_coffee_at_an_elegant_cafe_at_night_warm_window_light_soft_shadow_editorial_street_photography_no_faces_clearly_visible_stylized_and_intriguing&width=1200&height=800&seq=news-02-excl&orientation=landscape",
    author: "今日新瓜 · 数据组",
    time: "26 分钟前",
    views: 361000,
    likes: 19800,
    readMin: 7,
    tags: ["独家", "关系考据", "时间线"],
  },
  {
    id: 3,
    category: "exclusive",
    exclusive: true,
    title: "晚会压轴为何突然换人？编导一句话点破真相",
    lead: "临近开演三天，原定压轴嘉宾临时调整。今日新瓜独家连线晚会编导组，还原换人背后的真实理由。",
    body: [
      "公开说法是“档期冲突”，但编导组内部对今日新瓜透露，真正原因是排练效果与导演预期差距较大，节目形态需要重新设计。",
      "压轴位向来是整场晚会广告回报最高的时段，任何微调都会牵动赞助权益与转播表。因此换人并非临时起意，而是方案打磨到最后时刻的取舍。",
      "后续重排的节目效果究竟如何，建议读者以播出正片为准，避免被零散片段误导。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=grand_stage_awards_show_with_spotlight_and_confetti_dramatic_red_backdrop_silhouette_of_a_singer_holding_microphone_distant_crowd_no_faces_stylized_editorial_concert_photography&width=1200&height=800&seq=news-03-excl&orientation=landscape",
    author: "今日新瓜 · 前线组",
    time: "1 小时前",
    views: 274000,
    likes: 14200,
    readMin: 5,
    tags: ["独家", "晚会", "编导"],
  },
  {
    id: 4,
    category: "scene",
    hot: true,
    featured: true,
    title: "红毯图报：谁在认真营业，谁又靠一帧封神",
    lead: "某盛典红毯结束，编辑按“定妆、生图、动图”三层逐一复盘，看谁的营业既体面又聪明。",
    body: [
      "红毯永远是一场关于分寸的考试。定妆照负责体面，而真正被讨论的往往是媒体生图里那些松弛的瞬间。",
      "本轮复盘里，几位艺人的选衣逻辑明显更成熟——颜色避开撞衫雷区，剪裁贴合身形比例，妆容也一改前几年盲目加重眼影的倾向。",
      "当然，造型的好看与否最终是主观的。编辑部只想提醒：与其逐帧比较，不如看看完整造型后的设计思路，那才是营业质量的分水岭。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=fashion_red_carpet_event_with_female_silhouette_in_elegant_gown_long_train_camera_flashes_warm_editorial_glamour_warm_neutral_background_no_facial_details_stylized_luxury_fashion_photography&width=1200&height=800&seq=news-04-scene&orientation=landscape",
    author: "今日新瓜 · 造型组",
    time: "2 小时前",
    views: 520000,
    likes: 40100,
    readMin: 6,
    tags: ["红毯", "造型", "现场图报"],
  },
  {
    id: 5,
    category: "scene",
    title: "颁奖礼台侧镜头比正片更精彩，我们替你盯了全程",
    lead: "导播没切到的那些表情与低语，往往藏着整场活动的真实情绪。",
    body: [
      "颁奖礼的信息量远不止领奖那一分钟。镜头扫过的候场区、获奖者落座的瞬间、同组演员低声交换意见的画面，都是现场真正的看点。",
      "今日新瓜在现场蹲守全程，记录了几个值得留意的细节：几位提名者的手部小动作、后排艺人对台上发言的真实反应。",
      "需要说明的是，这些观察只是现场一隅，并不构成对任何人的评判，仅供读者当作看热闹的额外乐趣。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=behind_the_scenes_of_an_awards_ceremony_side_angle_audience_silhouettes_soft_television_glow_confetti_warm_golden_stage_lighting_no_faces_editorial_documentary_style&width=1200&height=800&seq=news-05-scene&orientation=landscape",
    author: "今日新瓜 · 前线组",
    time: "3 小时前",
    views: 198000,
    likes: 9600,
    readMin: 4,
    tags: ["颁奖礼", "现场", "观察"],
  },
  {
    id: 6,
    category: "scene",
    title: "发布会采访区实录：比通稿信息量大得多的三分钟",
    lead: "通稿之外，主创们在自由问答里松口了不少细节。",
    body: [
      "正式群访之后，往往有一段看似闲聊的自由问答环节，而真正有价值的信息常出现在这里。",
      "今日新瓜留意到，导演在被问及续篇时并未直接否认，反而提到了“还在补完世界观”的说法；主演也对某场戏的拍摄成本细节点了头。",
      "这些口风目前都处于“未官宣”状态，编辑部会持续追踪官方动态，读者请勿据此过度解读。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=press_conference_interview_zone_with_microphones_and_photographers_three_silhouettes_behind_a_podium_soft_studio_flash_warm_editorial_mood_no_faces_stylized&width=1200&height=800&seq=news-06-scene&orientation=landscape",
    author: "今日新瓜 · 采访组",
    time: "4 小时前",
    views: 156000,
    likes: 7300,
    readMin: 5,
    tags: ["发布会", "主创", "幕后"],
  },
  {
    id: 7,
    category: "star",
    hot: true,
    title: "顶流工作室悄悄改了运营节奏，这四个月他们在忙什么",
    lead: "从宣发频次到营业内容，一组可量化的变化暗示了其后的项目方向。",
    body: [
      "观察一个成熟工作室的动态，与其听口头规划，不如看它实际排期的变化。过去四个月，某顶流的公开营业出现了明显节奏调整。",
      "宣发物料从“高曝光、低质感”转向“少而精、重质感”，社交平台内容也开始出现更多与影视项目绑定的表达。",
      "种种迹象综合指向：团队正在为下一阶段的影视作品做前置铺垫。具体项目仍需以官方宣布为准，今日新瓜将持续关注。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=elegant_male_silhouette_in_front_of_a_warm_studio_light_and_production_notes_clipboard_soft_golden_hour_light_dramatic_shadow_editorial_portrait_no_clear_face&width=1200&height=800&seq=news-07-star&orientation=landscape",
    author: "今日新瓜 · 观察组",
    time: "5 小时前",
    views: 460000,
    likes: 28700,
    readMin: 7,
    tags: ["工作室", "宣发", "动态"],
  },
  {
    id: 8,
    category: "star",
    title: "出道十年综艺首常驻，这位演员主动暴露了“真我”",
    lead: "从不参加常驻综艺的演技派，为何这次破例？我们拆解其背后的选择逻辑。",
    body: [
      "对很多专注演戏的艺人来说，常驻综艺是一种需要谨慎对待的曝光。它带来流量，也可能消解角色塑造的神秘感。",
      "这次破例，与其说是商业选择，不如看作一次主动的形象再校准——用真实性格对冲长期的角色标签。",
      "从首两期表现看，其放松自然的表达确实与角色形象形成反差，这或许正是团队希望达到的效果。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=relaxed_person_sitting_in_armchair_laughing_in_a_warm_cozy_studio_interview_set_soft_lamplight_bookshelf_background_no_face_details_stylized_editorial&width=1200&height=800&seq=news-08-star&orientation=landscape",
    author: "今日新瓜 · 观察组",
    time: "6 小时前",
    views: 232000,
    likes: 12400,
    readMin: 5,
    tags: ["综艺", "演员", "形象"],
  },
  {
    id: 9,
    category: "star",
    title: "老牌歌手发行节奏骤缓，新一轮巡演或在悄悄排期",
    lead: "安静不等于停摆，行业排期表上总能找到蛛丝马迹。",
    body: [
      "近半年某老牌歌手的新作发布明显放缓，歌迷难免担忧。但多位演唱会主办方向今日新瓜透露，对方团队近期密集接触场馆档期。",
      "此类接触通常意味着巡演企划已进入实质推进阶段，而非单纯的市场试探。",
      "至于具体城市与规模，各方均守口如瓶。今日新瓜建议以官方票务公告为准，谨防非官方渠道“开票”诈骗。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=concert_stage_in_preparation_with_lights_being_tested_and_crew_setting_up_instruments_empty_venue_warm_amber_stage_lights_silhouettes_stylized_editorial&width=1200&height=800&seq=news-09-star&orientation=landscape",
    author: "今日新瓜 · 演出组",
    time: "8 小时前",
    views: 175000,
    likes: 8900,
    readMin: 6,
    tags: ["巡演", "歌手", "排期"],
  },
  {
    id: 10,
    category: "variety",
    hot: true,
    featured: true,
    title: "一档民宿综艺的“慢”，原来是精确计算的结果",
    lead: "为什么慢综艺要故意留白？我们访谈后期团队，拆解剪辑里的呼吸感。",
    body: [
      "观众以为的“随意”与真实录制的“随机”，在后期往往都是被精心校准过的结果。留白不是没素材，而是刻意控制叙事密度。",
      "据后期团队透露，本季民宿综艺删掉了大量戏剧冲突强烈的素材，转而保留生活流细节，目的是稳住节目“治愈感”的标签。",
      "这种取舍背后是清晰的人设运营与播出定位，慢只是表象，精密才是内核。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cozy_mountain_cabin_bnb_with_warm_lamps_people_quietly_relaxing_on_terrace_at_dusk_lush_green_hills_soft_warm_light_editorial_lifestyle_no_faces_clearly_shown&width=1200&height=800&seq=news-10-variety&orientation=landscape",
    author: "今日新瓜 · 制作组",
    time: "9 小时前",
    views: 388000,
    likes: 22600,
    readMin: 6,
    tags: ["慢综艺", "剪辑", "幕后"],
  },
  {
    id: 11,
    category: "variety",
    title: "竞技综艺为何总要安排“逆袭剧本”？这是行业公开的秘密",
    lead: "一次普通逆袭背后，藏着赛制设计与叙事的双重考量。",
    body: [
      "竞技类综艺里，“后来居上”之所以反复出现，是因为它同时服务于悬念与情绪两种需求。",
      "制作侧人士坦言，排期表上留出逆袭空间并非作弊，而是在真实实力的基础上，通过赛制与剪辑放大戏剧张力。",
      "换言之，结果多数真实，但叙事会主动选择更能打动人心的那条线。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=competitive_variety_show_set_with_contestant_silhouettes_on_golden_winner_podium_spotlights_and_dynamic_lighting_red_and_amber_palette_no_faces_dramatic_stylized&width=1200&height=800&seq=news-11-variety&orientation=landscape",
    author: "今日新瓜 · 制作组",
    time: "11 小时前",
    views: 204000,
    likes: 11300,
    readMin: 5,
    tags: ["竞技综艺", "赛制", "剪辑"],
  },
  {
    id: 12,
    category: "variety",
    title: "选秀类目回归，导师配置背后有一套“人气对冲”公式",
    lead: "导师阵容不是拍脑袋定的，我们拆解了常见的选角配比逻辑。",
    body: [
      "选秀节目导师席的人气对冲是一门生意经：既要有国民度担当稳住大盘，也要有流量担当拉新观众，还要有专业评审建立公信力。",
      "三者的比例与位置安排，通常会在录制前经过多轮方案推演，甚至要参考同期竞品的阵容做差异化。",
      "理解这套逻辑后，再看导师名单时，往往能读出节目组真正的市场野心。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=idol_audition_show_stage_with_judges_desk_silhouettes_and_a_contestant_in_spotlight_vibrant_stage_lights_warm_red_and_amber_no_faces_stylized&width=1200&height=800&seq=news-12-variety&orientation=landscape",
    author: "今日新瓜 · 制作组",
    time: "13 小时前",
    views: 167000,
    likes: 7800,
    readMin: 5,
    tags: ["选秀", "导师", "阵容"],
  },
  {
    id: 13,
    category: "trending",
    hot: true,
    featured: true,
    title: "一整晚的“反转连续剧”，吃瓜群众最该警惕的是什么",
    lead: "从爆料到辟谣再到二次反转，热度背后是流量逻辑，也是情绪陷阱。",
    body: [
      "这场持续整晚的话题接力，几乎集齐了瓜圈的经典配方：先行爆料、官方或当事人的快速否认、随后流出新的碎片信息。",
      "每一次“反转”都会让事件重回热度榜，但多数反转往往来自信息不全，而非真相被揭示。",
      "今日新瓜想提醒读者：吃瓜可以，但尽量等官方口径齐整后再下结论，避免被零散片段的情绪牵着走。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=moody_editorial_flat_lay_of_smartphone_with_notifications_timeline_and_newspaper_magnifying_glass_warm_desktop_lighting_red_and_amber_tones_dramatic_shadow_no_text_stylized&width=1200&height=800&seq=news-13-trend&orientation=landscape",
    author: "今日新瓜 · 热议组",
    time: "15 小时前",
    views: 610000,
    likes: 52300,
    readMin: 6,
    tags: ["反转", "热搜", "吃瓜"],
  },
  {
    id: 14,
    category: "trending",
    title: "同框即情侣？这届网友的联想力需要一个暂停键",
    lead: "从一段对视到全网嗑糖，我们复盘这类话题如何被一步步催化。",
    body: [
      "一段普通的活动对视视频，经过慢放、加字幕、配乐的处理后，被解读出无数层含义。话题随之登顶热搜。",
      "这种催化路径在瓜圈相当常见：先由切片引发联想，再靠二次创作放大，最后当事人不得不下场回应。",
      "编辑部并非否认一切可能，只是提醒：在没有当事人明确表态前，任何嗑糖都应止步于想象。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=two_people_sitting_across_a_table_making_eye_contact_in_a_warm_soft_light_romantic_but_unclear_shot_from_behind_no_faces_stylized_editorial_still&width=1200&height=800&seq=news-14-trend&orientation=landscape",
    author: "今日新瓜 · 热议组",
    time: "16 小时前",
    views: 295000,
    likes: 16800,
    readMin: 5,
    tags: ["同框", "联想", "舆论"],
  },
  {
    id: 15,
    category: "trending",
    title: "这条被删的帖子说了什么？我们拼出了完整时间线",
    lead: "爆款帖子忽然消失，反而让热度翻倍。还原帖子的生命周期与传播路径。",
    body: [
      "一个帖子从发布、冲上热榜再到被删除，整个过程往往不超过数小时，而这恰恰放大了围观者的好奇。",
      "今日新瓜通过公开的转载快照与平台时间戳，尽量还原了其原始内容与传播节点。",
      "需要说明的是，删帖未必代表内容真实，也可能是涉及隐私或侵权。我们始终倡导理性围观。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=analyst_workspace_with_timeline_chart_screenshots_and_trend_graphs_on_a_screen_warm_desk_lamp_red_accent_editorial_tech_flat_lay_no_text_stylized&width=1200&height=800&seq=news-15-trend&orientation=landscape",
    author: "今日新瓜 · 数据组",
    time: "18 小时前",
    views: 241000,
    likes: 13200,
    readMin: 7,
    tags: ["删帖", "时间线", "传播"],
  },
  {
    id: 16,
    category: "feature",
    hot: true,
    title: "从代际爆款到行业拐点：一支男团三年浮沉全记录",
    lead: "用三年时间轴，看一支现象级团体如何走到今天，以及它映射出的行业规律。",
    body: [
      "三年前这支团体用一首歌红遍全网时，几乎没人预料到其后的轨迹会如此陡峭。彼时的行业正处于流量红利期的尾巴。",
      "随后的解散传闻、成员个人发展、公司资源分配，几乎每一步都被放大审视。当我们把时间轴拉长，会发现很多争议其实早有伏笔。",
      "回看这三年，这支团体的起伏不只是个体命运，更是一部行业从狂热走向理性化的样本。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=long_exposure_timeline_mood_of_a_music_group_road_maps_and_concert_passes_on_a_dark_wooden_desk_warm_directional_light_deep_shadows_editorial_documentary_no_text&width=1200&height=800&seq=news-16-feature&orientation=landscape",
    author: "今日新瓜 · 特稿组",
    time: "昨天",
    views: 532000,
    likes: 33800,
    readMin: 12,
    tags: ["深度", "男团", "行业"],
  },
  {
    id: 17,
    category: "feature",
    title: "流量退潮之后，靠作品说话的演员赢回了什么",
    lead: "当算法红利退去，真正留下来的是把角色演到骨头里的人。",
    body: [
      "过去几年，“有演技却没流量”曾是一种尴尬的处境。而随着观众审美回归理性，一批靠作品说话的演员重新获得了议价能力。",
      "从选片策略到团队建设，他们的路径惊人相似：愿意接演复杂度更高的角色，也愿意为一部戏投入漫长的准备期。",
      "这种转变的背后，是行业泡沫被挤掉后，评价体系正在向更可持续的方向回归。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=portrait_of_a_focused_actor_silhouette_studying_a_script_in_dramatic_warm_side_lighting_theater_rehearsal_room_atmosphere_no_clear_face_editorial_photography&width=1200&height=800&seq=news-17-feature&orientation=landscape",
    author: "今日新瓜 · 特稿组",
    time: "前天",
    views: 402000,
    likes: 26100,
    readMin: 10,
    tags: ["深度", "演员", "行业观察"],
  },
  {
    id: 18,
    category: "feature",
    title: "短剧狂飙的这一年：谁赚到了钱，谁又在裸泳",
    lead: "高速增长的短剧赛道，正在经历一轮残酷的分化。",
    body: [
      "短剧在过去一年交出惊人数据的同时，也暴露出制作端与平台端的巨大温差。头部项目动辄吸金，腰部以下却普遍挣扎。",
      "对许多小团队而言，爆款靠的是对情绪点的精准拿捏，而非烧钱。而投流成本的分化，正在把行业推向强者愈强的格局。",
      "喧嚣过后，真正的问题或许不是“短剧还能火多久”，而是如何在同质化里建立可持续的内容壁垒。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=dramatic_split_lighting_of_a_phone_screen_with_a_vertical_video_and_money_profit_charts_warm_amber_vs_cool_shadow_duotone_editorial_tech_analysis_no_text_stylized&width=1200&height=800&seq=news-18-feature&orientation=landscape",
    author: "今日新瓜 · 特稿组",
    time: "3 天前",
    views: 356000,
    likes: 21000,
    readMin: 9,
    tags: ["深度", "短剧", "行业"],
  },
];

export const hotRank: number[] = [1, 4, 13, 7, 16, 10, 5, 12];

export const faqs = [
  {
    q: "什么是“今日新瓜”？",
    a: "今日新瓜是专注文娱领域的泛娱乐资讯平台，以独家内幕、独家爆料和深度栏目为核心，追踪明星动态、综艺现场与热点事件背后的来龙去脉。",
  },
  {
    q: "你们的“独家爆料”如何保证可信度？",
    a: "我们的内容以多源交叉核实为基本原则，编辑部对信源进行匿名与多角度比对，并对标注为“传闻”的信息明确区分，避免把未经证实的猜测当作事实呈现。",
  },
  {
    q: "发现报道中有失实信息，该如何反馈？",
    a: "您可以通过页面底部的联系邮箱向我们提供线索或纠错信息。确认信息不实后，我们会依据事实尽快修正或撤下相关报道，并保留必要的更正说明。",
  },
  {
    q: "怎样才能向你们投稿或提供内幕线索？",
    a: "欢迎通过底部邮箱投稿。为保护信源，请勿在正文透露敏感个人信息，编辑部会优先处理信息完整、可交叉核实的线索。",
  },
  {
    q: "本站内容会涉及真实人物与真实事件吗？",
    a: "本站以泛娱乐栏目呈现为主，所涉人物、团体与事件设定多为编辑部策划的演示性内容，请理性看待，勿将虚拟演绎与现实对号入座。",
  },
  {
    q: "转载站内文章需要注意什么？",
    a: "欢迎规范转载。请保留来源署名与原文链接，并对原文进行完整呈现，禁止断章取义或擅自改动标题与事实性表述，商业转载请先取得授权。",
  },
];

export const testimonials = [
  {
    name: "一位追星十年的老粉",
    role: "读者",
    text: "别的平台只给你结论，今日新瓜愿意把来龙去脉摊开给你看，追星多年第一次觉得吃瓜能吃得这么明白。",
  },
  {
    name: "影视行业从业者",
    role: "从业者",
    text: "很多行业观察相当贴近一线实情，看得出是认真做了功课的，不是纯标题党。",
  },
  {
    name: "普通吃瓜网友",
    role: "读者",
    text: "最喜欢它的“理性吃瓜”态度，每次反转热搜来袭，都会先来看看时间线整理，避免被带节奏。",
  },
];